// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import CustomFieldsFormController from "./custom_fields_form_controller.js"
application.register("custom-fields-form", CustomFieldsFormController)

import LoaderController from "./loader_controller.js"
application.register("loader", LoaderController)

import ToastController from "./toast_controller.js"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller.js"
application.register("tooltip", TooltipController)

import SingleUploadController from "./single_upload_controller.js"
application.register("single-upload", SingleUploadController)

import MultipleUploadController from "./multiple_upload_controller.js"
application.register("multiple-upload", MultipleUploadController)
